var _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroLeftCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 567,
    viewBox: "0 0 637 567",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_61_1037)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 239.562,
    cy: 345.643,
    r: 32.5,
    transform: "rotate(59.1783 239.562 345.643)",
    fill: "url(#paint0_linear_61_1037)",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_61_1037)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240.728,
    cy: 341.047,
    r: 25,
    transform: "rotate(59.1783 240.728 341.047)",
    fill: "url(#paint1_linear_61_1037)",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_61_1037)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.6764,
    cy: 90.6764,
    rx: 66.1324,
    ry: 66.1324,
    transform: "rotate(59.1783 90.6764 90.6764)",
    fill: "url(#paint2_linear_61_1037)",
    fillOpacity: 0.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_61_1037)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.3975,
    cy: 72.0241,
    rx: 44.0883,
    ry: 44.0883,
    transform: "rotate(59.1783 95.3975 72.0241)",
    fill: "url(#paint3_linear_61_1037)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_61_1037)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.1,
    cy: 45.1,
    rx: 45.1,
    ry: 45.1,
    transform: "matrix(0.512367 0.858767 -0.858766 0.512368 121.601 442.708)",
    fill: "url(#paint4_linear_61_1037)",
    fillOpacity: 0.8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_61_1037)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.3286,
    cy: 19.3286,
    r: 19.3286,
    transform: "matrix(0.512367 0.858767 -0.858766 0.512368 96.1348 429.822)",
    fill: "url(#paint5_linear_61_1037)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_61_1037)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 598.649,
    cy: 484.788,
    r: 27.5,
    transform: "rotate(59.1783 598.649 484.788)",
    fill: "url(#paint6_linear_61_1037)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_61_1037",
    x: 202.057,
    y: 308.138,
    width: 75.01,
    height: 75.01,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_61_1037"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_61_1037",
    x: 213.724,
    y: 316.043,
    width: 54.0077,
    height: 54.0077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_61_1037"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_61_1037",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_61_1037",
    x: 2.48968,
    y: 2.48968,
    width: 176.373,
    height: 176.373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0221,
    result: "effect1_foregroundBlur_61_1037"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_61_1037",
    x: 51.3024,
    y: 27.929,
    width: 88.1901,
    height: 97.0077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.81765
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.40883
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_61_1037"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_61_1037",
    x: 53.1401,
    y: 451.708,
    width: 105.677,
    height: 105.677,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.86571,
    result: "effect1_foregroundBlur_61_1037"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_61_1037",
    x: 70.1079,
    y: 436.993,
    width: 38.6631,
    height: 43.8174,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.15428
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.15428
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_61_1037"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_61_1037",
    x: 567.145,
    y: 453.283,
    width: 63.0084,
    height: 63.0084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_61_1037"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_1037",
    x1: 239.562,
    y1: 313.143,
    x2: 239.562,
    y2: 378.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4DDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_1037",
    x1: 240.728,
    y1: 316.047,
    x2: 240.728,
    y2: 366.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6E6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5FDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_1037",
    x1: 90.6764,
    y1: 24.544,
    x2: 90.6764,
    y2: 156.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4D4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_61_1037",
    x1: 95.3975,
    y1: 27.9358,
    x2: 95.3975,
    y2: 116.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_61_1037",
    x1: 45.1,
    y1: 0,
    x2: 45.1,
    y2: 90.1999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE3E2",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_61_1037",
    x1: 19.3286,
    y1: 0,
    x2: 19.3286,
    y2: 38.6571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_61_1037",
    x1: 598.649,
    y1: 457.288,
    x2: 598.649,
    y2: 512.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8EDF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroLeftCircles);
export default __webpack_public_path__ + "static/media/hero_left_circles.e9bfe312832366063b3c5af7385e917e.svg";
export { ForwardRef as ReactComponent };